module.exports = __webpack_public_path__ + "static/media/DFD-BUSD.2de2acf9.svg";